import {DashboardCard} from '../dashboard-card/DashboardCard'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {formatCurrency} from '@/utilities/helpers'
import {useGetDashboardAnalytics} from '../../query/useGetDashboardAnalytics'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {DashboardEconomicSearchParams} from '../../types'
import {useMemo} from 'react'
import {DashboardSimpleCardSkeleton} from '../dashboard-simple-card-skeleton/DashboardSimpleCardSkeleton'
import {calculateFirstMargin} from '../../utils'

export const DashboardFirstMarginCard = () => {
    const {t} = useTranslation()
    const {searchParams} = useParsedSearchParams(DashboardEconomicSearchParams)
    const {data, isLoading} = useGetDashboardAnalytics({
        fields: ['billedAccesses', 'costs', 'otherCosts'],
        ...searchParams
    })
    const firstMargin = useMemo(() => {
        return calculateFirstMargin(data?.billedAccesses?.accesses, data?.costs?.total)
    }, [data?.billedAccesses?.accesses, data?.costs?.total])

    if (isLoading) {
        return <DashboardSimpleCardSkeleton title={t('dashboard:first_margin')} />
    }

    return (
        <DashboardCard title={t('dashboard:first_margin')}>
            <Text palette="neutral" shade="900" size="textXl" weight={700}>
                {formatCurrency(firstMargin)}
            </Text>
        </DashboardCard>
    )
}
